"use strict";
// ── Districts ──────────────────────────────────────────────────────────────────
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildDistrictFeatures = buildDistrictFeatures;
exports.resolveGameRecordIcon = resolveGameRecordIcon;
function buildDistrictFeatures(districts) {
    var _a;
    const features = [];
    for (const d of districts) {
        if (typeof (d === null || d === void 0 ? void 0 : d.getOutlinesAsFeatureList) !== 'function')
            continue;
        try {
            const outlineFeatures = (_a = d.getOutlinesAsFeatureList()) !== null && _a !== void 0 ? _a : [];
            outlineFeatures.forEach(f => {
                var _a;
                features.push(Object.assign(Object.assign({}, f), { properties: Object.assign(Object.assign({}, ((_a = f.properties) !== null && _a !== void 0 ? _a : {})), { id: d.identifier }) }));
            });
        }
        catch (e) {
            console.error(`[buildDistrictFeatures] Failed for district ${d.identifier}`, e);
        }
    }
    return features;
}
// ── Game records ───────────────────────────────────────────────────────────────
const WILDART_ICON_MAP = {
    schwarzwild: 'icnSchwarzwild',
    damwild: 'icnDamwild',
    rehwild: 'icnRehwild',
    nutria: 'icnNutria',
    fuchs: 'icnFuchs',
    dachs: 'icnDachs',
    waschbär: 'icnWaschbär',
    sikawild: 'icnSikawild',
    muntjac: 'icnMuntjac',
    muffelwild: 'icnMuffelwild',
    rotwild: 'icnRotwild',
};
/** Resolve a game record's Wildart name to a Mapbox icon identifier. */
function resolveGameRecordIcon(wildart) {
    var _a;
    return (_a = WILDART_ICON_MAP[wildart === null || wildart === void 0 ? void 0 : wildart.toLowerCase()]) !== null && _a !== void 0 ? _a : 'icon-pin';
}
